import { createContext } from "react";
import { CoachClientGenericQuery$data } from "../routes/coach/client/generic/__generated__/CoachClientGenericQuery.graphql";

export interface IClientContextProps {
  coachClientQuery: any;
  setCoachClientQuery: (coachClientQuery: any) => void;
}

export const ClientContext = createContext<IClientContextProps | undefined>(
  undefined,
);
